<div class="grievance-page">
  <app-header-style-seven></app-header-style-seven>

  <section class="page-shell grievance-shell">
    <div class="custom-container">
      <div class="content-shell grievance-content-shell">
        <!-- HERO -->
        <header class="page-hero">
          <span class="page-kicker">Student Support</span>
          <h1>Grievance Redressal Committee</h1>
          <p>
            Committee constituted as per Anna University affiliation norms and
            AICTE regulations to address student grievances in a fair and timely
            manner.
          </p>
        </header>

        <!-- INTRO -->
        <section
          class="info-card"
          [class.dark-experience-area]="themeService.isDark()"
        >
          <div class="info-copy">
            <p>
              The Grievance Redressal Committee is constituted as per the revised
              affiliation format of Anna University, Chennai and based upon the
              AICTE Regulations 2012. This committee meets as and when required
              to look into complaints and grievances raised by students.
            </p>
            <p>
              The members prepare a report based on the findings and submit it to
              the Principal for forwarding the same to the Ombudsman and the
              affiliating University wherever necessary.
            </p>
          </div>
        </section>

        <!-- COMMITTEE -->
        <section class="panel-card">
          <div class="panel-head">
            <div>
              <span class="panel-tag">Institution Committee</span>
              <h2>Grievance Redressal Committee</h2>
            </div>

            <a
              class="pdf-link"
              href="assets/pdfs/grc.pdf"
              target="_blank"
              rel="noopener"
            >
              Open PDF
            </a>
          </div>

          <div class="row g-4 align-items-start">
            <div class="col-lg-4 col-md-12">
              <div class="pdf-card">
                <a href="assets/pdfs/grc.pdf" target="_blank" rel="noopener">
                  <img
                    src="assets/pdfs/grc.jpg"
                    class="pdf-image"
                    alt="Grievance Redressal Committee PDF preview"
                    loading="lazy"
                  />
                </a>
                <div class="pdf-caption">Committee resolution / PDF preview</div>
              </div>
            </div>

            <div class="col-lg-8 col-md-12">
              <div class="table-wrap">
                <table class="table committee-table">
                  <thead>
                    <tr>
                      <th>S.No</th>
                      <th>Name</th>
                      <th>Position</th>
                      <th>Category</th>
                      <th>Occupation</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr *ngFor="let m of committeeMembers; trackBy: trackBySlno">
                      <td>{{ m.slno }}</td>
                      <td>{{ m.name }}</td>
                      <td>{{ m.position }}</td>
                      <td>{{ m.category }}</td>
                      <td>{{ m.occupation }}</td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </section>
      </div>
    </div>
  </section>
</div>